<template>
  <div class="selector-wrapper">
    <div class="label">{{label}}</div>
    <div
      class="form-group variable-selector box">
      <vue-taggable-select
        :key="taggableMultiselectKey"
        class="taggable-select"
        v-if="!disabled"
        :options="variables"
        v-model="taggableSelectedVariables"
        :option-label="'label'"
        :placeholder="''"
        :max-results="getMaxResults"/>
      <multi-select
        v-else
        class="multi-select"
        :options="getOptions"
        :selected-options="getSelectedVariables"
        :isDisabled="disabled"
        :isError="error"
        :placeholder="label"/>
      <btn-pill
        v-if="!disabled"
        class="tags-btn"
        @click="showModal = true"
        btn-size="s"
        btn-type="secondary">
        <font-awesome-icon
          :icon="icon.tags"/>
        {{ $t('variables.variableSelector') }}
      </btn-pill>
    </div>
    <variable-multiple-selector-modal
      v-if="showModal"
      v-on:close="showModal = false"
      v-model="variable"
      :taggedVariables="taggedVariables"
      :taggableVariables="taggableSelectedVariables"
      v-on:input="$emit('input', variable)"
      v-on:selectedTaggableVariables="setTaggableVariables"
      v-on:selectedTagsChanged="selectedTagsChanged"
      :variables="variables"
      :selected-tags="selectedTags"
      :tree="tree"/>
  </div>
</template>

<script>
import VariableMultipleSelectorModal from '@/components/variable/VariableMultipleSelectorModal';
import vSelect from 'vue-select';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faTags } from '@fortawesome/pro-regular-svg-icons';
import BtnPill from '@/components/shared/buttons/BtnPill';
import 'vue-search-select/dist/VueSearchSelect.css';
import { MultiSelect } from 'vue-search-select';
import VueTaggableSelect from '@/components/shared/forms/vueTaggableSelect/VueTaggableSelect';
import variableSelectorMixin from '@/components/explorer/variableSelectorMixin';

export default {
  name: 'LabelVariableMultipleSelector',
  components: {
    BtnPill,
    vSelect,
    VariableMultipleSelectorModal,
    FontAwesomeIcon,
    MultiSelect,
    VueTaggableSelect
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    variables: {
      type: Array,
      default: () => []
    },
    taggedVariables: {
      type: Array,
      default: () => []
    },
    tree: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'Error'
    }
  },
  watch: {
    variables: {
      handler: function (variables) {
        this.taggableMultiselectKey += 1;
      }
    },
    value: {
      handler: function (value) {
        this.variable = value;
      }
    },
    taggableSelectedVariables: {
      handler: function (selectedVariables) {
        this.variable = selectedVariables.map(item => item.id);
        this.$emit('input', this.variable);
      }
    }
  },
  mixins: [
    variableSelectorMixin
  ],
  data () {
    return {
      variable: this.value,
      showModal: false,
      icon: {
        tags: faTags
      },
      taggableSelectedVariables: [],
      taggableMultiselectKey: 0,
      selectedTags: []
    };
  },
  computed: {
    getOptions () {
      return createOptions(this.variables);
    },
    getSelectedVariables () {
      return this.getOptions.filter(option => this.variable.includes(option.value));
    }
  }
};

const createOptions = (nodes) => {
  const options = [];
  for (let i = 0; i < nodes.length; i++) {
    const option = {
      value: nodes[i].id,
      text: nodes[i].label
    };

    options.push(option);
  }

  return options;
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .tags-btn {
    white-space: nowrap;
    margin-left: $sp-margin-smaller;
  }

  .box {
    display: -webkit-box;
  }

  .label {
    color: rgba(17, 17, 17, 0.5);
  }

  /deep/ .taggable-select, .multi-select {
    width: 25rem !important;
  }

  /deep/ .taggable-select ul {
    overflow-x: auto !important;
  }

  .selector-wrapper {
    width: 50rem;
  }

  .form-group {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/variable/LabelVariableMultipleSelector.vue